module.exports = __webpack_public_path__ + "img/4-3s.8b642bd3.jpg";